export default __webpack_public_path__ + "media/images/corporate/apartments/first_slide_md-b44e513cbdd59cef16b57bf8afed20c4.png";